import { z } from 'zod';

export const uboSchema = z.object({
  firstName: z.string().nonempty(),
  lastName: z.string().nonempty(),
  email: z.string().email(),
  birthdate: z.string().nonempty(),
  birthCity: z.string().nonempty(),
  birthCountry: z.string().nonempty(),
  nationality: z.string().nonempty(),
});
